import {put} from 'redux-saga/effects';
import {showDialog, showDialogSuccess} from "../action.creators/dialog.actions";

export const showDialogSaga = function* (payload: ReturnType<typeof showDialog>) {
    yield put(showDialogSuccess(payload.content, payload.settings))
};
